<!--相关线索类组件-->
<template>
    <transition name="relateTips">
    <div class="relateRepliesWrapper" v-show="show">
        <ul class="quNoFull">
            <li v-for="(item,ix) in currList" :key="`q-link-${ix}`" class="itemCls"
                @click="()=>onAsk(list[ix])" v-html="item"><span>{{item.name}}</span></li>
        </ul>
    </div>
    </transition>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import RButton from '../Use/r-button'

    export default {
        name: "RelateReplies",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            currList :{
                type: Array,
                default: []
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {

            };

        },
        mounted() {

        },
        methods: {
            ...mapActions([

            ]),
            ...mapMutations([
                "contactDisData"
            ]),
            onAsk(value){
                this.$emit('on-ask',value)
            }

        }
    };
</script>
<style lang="less">
    .relateTips-enter-active{
        transition: all .6s;
    }
    .relateTips-leave-active {
        transition: all 0s;
    }

    .relateTips-enter,
    .relateTips-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
    .relateRepliesWrapper {
        width: 100%;
        /*position: fixed;*/
        position: absolute;
        bottom: 1.8rem;
        left: 0;
        z-index: 1000;

        .quNoFull {
            width: 9.4rem;
            box-sizing: border-box;
            margin: 0 auto;
            background: #fff;
            border-radius: .5rem .5rem .3rem .5rem;
            padding: .4rem .6rem .4rem .8rem;
            box-shadow:-7px 0px 5px 0px rgba(0,0,0,0.03);
            li {
                list-style-type: disc;
                color: #666;
                padding: .3rem 0 .3rem .3rem;
                font-size: .32rem;

            }
        }



    }

</style>
